import { ApolloError } from "@apollo/client";

const SLOT_MINUTES = 15;
const SLOTS_PER_HOUR = 60 / SLOT_MINUTES;
const HOURS_PER_DAY = 24;
// The API accepts every 1 to 24 hours.
const MAX_INTERVAL_HOURS = 24;
// The workday schedule: every 5 to 60 minutes in steps of 5 in the window,
// every 1 to 12 hours outside it.
const WINDOW_INTERVAL_STEP_MINUTES = 5;
const MAX_WINDOW_INTERVAL_MINUTES = 60;
const MAX_OUTSIDE_INTERVAL_HOURS = 12;

// The quarter hours a daily schedule can start at, Europe/Berlin.
export const DAILY_TIMES: string[] = Array.from({ length: HOURS_PER_DAY * SLOTS_PER_HOUR }, (_, slot) =>
  [Math.floor(slot / SLOTS_PER_HOUR), (slot % SLOTS_PER_HOUR) * SLOT_MINUTES]
    .map(part => String(part).padStart(2, "0"))
    .join(":")
);
export const INTERVAL_HOURS: number[] = Array.from({ length: MAX_INTERVAL_HOURS }, (_, index) => index + 1);
export const DEFAULT_DAILY_TIME = "03:00";
export const DEFAULT_INTERVAL_HOURS = 6;

export const WINDOW_INTERVAL_MINUTES: number[] = Array.from(
  { length: MAX_WINDOW_INTERVAL_MINUTES / WINDOW_INTERVAL_STEP_MINUTES },
  (_, index) => (index + 1) * WINDOW_INTERVAL_STEP_MINUTES
);
export const OUTSIDE_INTERVAL_HOURS: number[] = Array.from(
  { length: MAX_OUTSIDE_INTERVAL_HOURS },
  (_, index) => index + 1
);
export const DEFAULT_WINDOW_START = "08:00";
export const DEFAULT_WINDOW_END = "20:00";
export const DEFAULT_WINDOW_INTERVAL_MINUTES = 5;
export const DEFAULT_OUTSIDE_INTERVAL_HOURS = 4;

// The codes the integration API refuses a request with; each has a message.
const KNOWN_ERROR_CODES = new Set([
  "salesforce-login-url-invalid",
  "salesforce-client-id-invalid",
  "salesforce-client-secret-invalid",
  "salesforce-client-secret-required",
  "salesforce-anonymization-required",
  "salesforce-schedule-invalid",
  "salesforce-integration-not-configured",
]);

// The message key for a refused request; null for an unexpected error.
export const salesforceIntegrationErrorKey = (error: unknown): string | null => {
  const code = error instanceof ApolloError ? error.graphQLErrors[0]?.message : undefined;
  return code && KNOWN_ERROR_CODES.has(code) ? `salesforceIntegration.errors.${code}` : null;
};
